import React from "react";

type OwnProps = {};
type MarpolProps = React.PropsWithChildren<OwnProps>;
function Marpol(props: MarpolProps) {
	return <div className="h-full">{props.children}</div>;
}

export default Marpol;
